import axios from "axios"
import ENV from "../config/env"

export const CREATE = 'CREATE'
export const GET_ALL_LICENCE = 'GET_ALL'
export const GET_LICENCES_CLUB = 'GET_LICENCES_CLUB'
export const GET_LICENCES_WAITING = 'GET_LICENCES_WAITING'
export const GET_BY_ID = 'GET_BY_ID'
export const LICENCES_DISPATCH = 'LICENCES_DISPATCH'
export const UPDATE_LICENCE = 'UPDATE_LICENCE'
export const UPDATE_LICENCE_MULTIPLE = 'UPDATE_LICENCE_MULTIPLE'
export const GET_LICENCES_SOLO = 'GET_LICENCES_SOLO'

const dispatchLicence = (type, payload) => ({type: type, payload: payload})
const token = localStorage.getItem('token')

const resetToken = async () => {
    await localStorage.removeItem('token')
    window.location.reload()
}

export const create = data => dispatch => {
    return axios.post(`${ENV.API}/licence`, data, {headers: {'x-access-token': token}})
        .then(res => {
            if (res.data.errmsg) {
                alert(res.data.errmsg)
                dispatch(dispatchLicence(CREATE, false))
                return false
            } else {
                console.log(res)
                dispatch(dispatchLicence(CREATE, res.data))
                return true
            }
        })
        .catch(err => {
            console.log(err)
        })
}

export const getAllLicences = () => dispatch => {
    return axios.get(`${ENV.API}/licences`, {headers: {'x-access-token': token}})
        .then(res => {
            if (res.data.errmsg) {
                if (!res.data.err) resetToken()
                else {
                    alert(res.data.errmsg)
                    dispatch(dispatchLicence(GET_ALL_LICENCE, false))
                }
                return false
            } else {
                dispatch(dispatchLicence(GET_ALL_LICENCE, res.data))
                return res.data
            }
        })
        .catch(err => {
            console.log(err)
        })
}

export const getLicencesWaiting = () => dispatch => {
    return axios.get(`${ENV.API}/licences-waiting`, {headers: {'x-access-token': token}})
        .then(res => {
            if (res.data.errmsg) {
                alert(res.data.errmsg)
                dispatch(dispatchLicence(GET_LICENCES_WAITING, false))
                return false
            } else {
                dispatch(dispatchLicence(GET_LICENCES_WAITING, res.data))
                return res.data
            }
        })
        .catch(err => {
            console.log(err)
        })
}

export const getLicencesSolo = () => dispatch => {
    return axios.get(`${ENV.API}/licences-solo`, {headers: {'x-access-token': token}})
        .then(res => {
            if (res.data.errmsg) {
                alert(res.data.errmsg)
                dispatch(dispatchLicence(GET_LICENCES_SOLO, false))
                return false
            } else {
                dispatch(dispatchLicence(GET_LICENCES_SOLO, res.data))
                return res.data
            }
        })
        .catch(err => {
            console.log(err)
        })
}

export const getLicencesByClub = data => dispatch => {
    return axios.post(`${ENV.API}/licences-club/${data.id}`, {idClubs: data.idClubs}, {headers: {'x-access-token': token}})
        .then(res => {
            if (res.data.errmsg) {
                alert(res.data.errmsg)
                dispatch(dispatchLicence(GET_LICENCES_CLUB, false))
                return false
            } else {
                dispatch(dispatchLicence(GET_LICENCES_CLUB, res.data))
                return res.data
            }
        })
        .catch(err => {
            console.log(err)
        })
}

export const getLicenceById = data => dispatch => {
    return axios.get(`${ENV.API}/licence/${data.id}`, {headers: {'x-access-token': token}})
        .then(res => {
            if (res.data.errmsg) {
                alert(res.data.errmsg)
                dispatch(dispatchLicence(GET_BY_ID, false))
                window.location.href = `/club/${localStorage.getItem('idClub')}`
                return false
            } else {
                dispatch(dispatchLicence(GET_BY_ID, res.data))
                return res.data
            }
        })
        .catch(err => {
            console.log(err)
        })
}

export const dispatchLicences = licences => dispatch => {
    dispatch(dispatchLicence(LICENCES_DISPATCH, licences))
    return true
}

export const updateLicence = data => dispatch => {
    return axios.post(`${ENV.API}/licence/${data._id}`, data, {headers: {'x-access-token': token}})
        .then(res => {
            if (res.data.errmsg) {
                alert(res.data.errmsg)
                dispatch(dispatchLicence(UPDATE_LICENCE, false))
                return false
            } else {
                dispatch(dispatchLicence(UPDATE_LICENCE, res.data))
                return res.data
            }
        })
        .catch(err => {
            console.log(err)
        })
}

export const updateMultipleLicences = (data, idClub) => dispatch => {
    return axios.post(`${ENV.API}/update-validite`,{data, idClub}, {headers: {'x-access-token': token}})
        .then(res => {
            if (res.data.errmsg) {
                alert(res.data.errmsg)
                dispatch(dispatchLicence(UPDATE_LICENCE_MULTIPLE, false))
                return false
            } else if (res.data.nbLicencesGood !== data.length) {
                alert("Toutes les licences n'ont pas été mises à jour, veuillez vérifier")
            } else {
                dispatch(dispatchLicence(UPDATE_LICENCE_MULTIPLE, res.data))
                return res.data
            }
        })
        .catch(err => {
            console.log(err)
        })
}

export const updateLicencesValid = ids => dispatch => {
    return axios.post(`${ENV.API}/valid-waiting`, {ids: ids}, {headers: {'x-access-token': token}})
        .then(res => {
            if (res.data.errmsg) {
                alert(res.data.errmsg)
                return false
            } else return res.data
        })
        .catch(err => {
            console.log(err)
        })
}

export const nextLicenceNumber = (typeLicence) => dispatch => {
    return axios.get(`${ENV.API}/next-licence/${typeLicence}`, {headers: {'x-access-token': token}})
        .then(res => {
            if (res.data.errmsg) {
                alert(res.data.errmsg)
                return false
            } else return res.data
        })
        .catch(err => {
            console.log(err)
        })
}

export const exportLicences = () => dispatch => {
    return axios.get(`${ENV.API}/export-licences`, {headers: {'x-access-token': token}})
        .then(res => {
            if (res.data.errmsg) {
                alert(res.data.errmsg)
                return false
            } else return res.data
        })
        .catch(err => {
            console.log(err)
        })
}
